import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=6c3b41fd&lang=pug"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=6c3b41fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports